module.exports = __webpack_public_path__ + "static/media/cert-todo.2834e4e2.png";